import { ApolloClient, gql, InMemoryCache } from "@apollo/client";
import { addTranslation, setTranslations } from "../../store/slices/i18nSlice";

const GET_TRANSLATION_BY_ID_AND_LANG = gql`
  query getTranslation($language: String, $id: String) {
    translationById(lang: $language, id: $id)
  }
`;

const GET_ALL_TRANSLATIONS = gql`
  query getAllTranslations($language: String!) {
    allTranslations(lang: $language)
  }
`;

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_BASE_URL || window.location.origin}/gql`,
  cache: new InMemoryCache(),
});

async function fecthTranslationById(language, id) {
  const response = await client.query({
    query: GET_TRANSLATION_BY_ID_AND_LANG,
    variables: { language, id },
  });
  return await response.data.translationById;
}

export const fetchTranslation = (language, id) => async dispatch => {
  try {
    dispatch(addTranslation({ [id]: "Loading..." }));
    const translation = await fecthTranslationById(language, id);
    dispatch(addTranslation({ [id]: translation }));
  } catch (error) {}
};

export async function fetchAllTranslations(currentTranslations, language) {
  const updatedTranslations = { ...currentTranslations };
  const ids = Object.keys(currentTranslations);

  for (const id of ids) {
    try {
      updatedTranslations[id] = await fecthTranslationById(language, id);
    } catch (error) {}
  }
  return updatedTranslations;
}

async function fetchAllTranslationsForLanguage(language) {
  const response = await client.query({
    query: GET_ALL_TRANSLATIONS,
    variables: { language },
  });
  return response.data.allTranslations;
}

export const loadAllTranslations = language => async dispatch => {
  try {
    const translations = await fetchAllTranslationsForLanguage(language);
    dispatch(setTranslations(translations));
  } catch (error) {
    console.error("Failed to load translations:", error);
    throw error;
  }
};
